/*! @vuukle/utils v3.1.1 by Ross <ross@vuukle.com> */
/**
 * Utilities with Browser API usage
 */

/**
 * Just log message to console if it's dev mode
 * @param {string} message
 * @param {'warn' | 'log' | 'error' | 'table'} type
 */
function makeDevLog() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'warn';
  if (process.env.NODE_ENV === 'development') {
    for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      rest[_key - 1] = arguments[_key];
    }
    console[type](...rest);
  }
}

// TODO: check which pieces of code still use it and replace with URLSearchParam
/**
 * Get query parameter value from the URL (window.location.href)
 * @name getURLParams
 * @param {string} paramName - parameter from which we want to get value
 * @returns {string} returns value of query parameter or empty string if parameter doesn't exist inside URL
 * @example
 *  getURLParams('id') // => ''
 */
var getURLParams = paramName => {
  paramName = paramName.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  var regexS = '[\\?&]' + paramName + '=([^&#]*)';
  var regex = new RegExp(regexS);
  var results = regex.exec(window.location.href);
  return results === null ? '' : results[1];
};

/**
 * @name detectBrowser
 * @description Detect browser
 * detectBrowser().name - browser name
 * detectBrowser().version - browser version
 */
function detectBrowser() {
  var ua = navigator.userAgent;
  var tem;
  var M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
  if (/trident/i.test(M[1])) {
    tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
    return {
      name: 'IE',
      version: tem[1] || ''
    };
  }
  if (M[1] === 'Chrome') {
    tem = ua.match(/\bOPR|Edge\/(\d+)/);
    if (tem != null) {
      return {
        name: 'Opera',
        version: tem[1]
      };
    }
  }
  M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
  /* tslint:disable */
  if ((tem = ua.match(/version\/(\d+)/i)) != null) {
    // $FlowFixMe
    M.splice(1, 1, tem[1]);
  }
  /* tslint:enable */
  return {
    name: M[0],
    version: M[1]
  };
}

/**
 * @name getBrowserName
 * @description detect the browser (no version detection)
 * Returns one of the detected options or 'unknown' if not found
 */
function getBrowserName() {
  var isIE = !!document.documentMode;
  var isEdge = !isIE && !!window.StyleMedia;
  var isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);
  var isEdgeChromium = isChrome && navigator.userAgent.indexOf('Edg') !== -1;
  if (!!window.opr && !!window.opr.addons || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0) {
    return 'Opera';
  }
  if (typeof window.InstallTrigger !== 'undefined') {
    return 'Mozilla Firefox';
  }
  if (navigator.userAgent.match(/safari/)) {
    return 'Safari';
  }
  if (isIE) {
    return 'Internet Explorer';
  }
  if (isEdge || isEdgeChromium) {
    return 'Edge';
  }
  if (isChrome) {
    return 'Google Chrome';
  }
  return 'unknown';
}

/** Code taken from ismobilejs library as it wasn't getting transformed by babel properly */
function isMobileV2(userAgent) {
  var appleIphone = /iPhone/i;
  var appleIpod = /iPod/i;
  var appleTablet = /iPad/i;
  var androidPhone = /\bAndroid(?:.+)Mobile\b/i;
  var androidTablet = /Android/i;
  var amazonPhone = /(?:SD4930UR|\bSilk(?:.+)Mobile\b)/i;
  var amazonTablet = /Silk/i;
  var windowsPhone = /Windows Phone/i;
  var windowsTablet = /\bWindows(?:.+)ARM\b/i;
  var otherBlackBerry = /BlackBerry/i;
  var otherBlackBerry10 = /BB10/i;
  var otherOpera = /Opera Mini/i;
  var otherChrome = /\b(CriOS|Chrome)(?:.+)Mobile/i;
  var otherFirefox = /Mobile(?:.+)Firefox\b/i;
  function match(regex, UA) {
    return regex.test(UA);
  }
  userAgent = userAgent || (typeof navigator !== 'undefined' ? navigator.userAgent : '');
  var tmp = userAgent.split('[FBAN');
  if (typeof tmp[1] !== 'undefined') {
    userAgent = tmp[0];
  }
  tmp = userAgent.split('Twitter');
  if (typeof tmp[1] !== 'undefined') {
    userAgent = tmp[0];
  }
  var result = {
    amazon: {
      device: match(amazonPhone, userAgent) || match(amazonTablet, userAgent),
      phone: match(amazonPhone, userAgent),
      tablet: !match(amazonPhone, userAgent) && match(amazonTablet, userAgent)
    },
    android: {
      device: !match(windowsPhone, userAgent) && (match(amazonPhone, userAgent) || match(amazonTablet, userAgent) || match(androidPhone, userAgent) || match(androidTablet, userAgent)) || match(/\bokhttp\b/i, userAgent),
      phone: !match(windowsPhone, userAgent) && match(amazonPhone, userAgent) || !match(windowsPhone, userAgent) && match(androidPhone, userAgent),
      tablet: !match(windowsPhone, userAgent) && !match(amazonPhone, userAgent) && !match(androidPhone, userAgent) && (match(amazonTablet, userAgent) || match(androidTablet, userAgent))
    },
    any: false,
    apple: {
      device: (match(appleIphone, userAgent) || match(appleIpod, userAgent) || match(appleTablet, userAgent)) && !match(windowsPhone, userAgent),
      ipod: match(appleIpod, userAgent),
      phone: match(appleIphone, userAgent) && !match(windowsPhone, userAgent),
      tablet: !match(appleIphone, userAgent) && match(appleTablet, userAgent) && !match(windowsPhone, userAgent)
    },
    other: {
      blackberry: match(otherBlackBerry, userAgent),
      blackberry10: match(otherBlackBerry10, userAgent),
      chrome: match(otherChrome, userAgent),
      device: match(otherBlackBerry, userAgent) || match(otherBlackBerry10, userAgent) || match(otherOpera, userAgent) || match(otherFirefox, userAgent) || match(otherChrome, userAgent),
      firefox: match(otherFirefox, userAgent),
      opera: match(otherOpera, userAgent)
    },
    phone: false,
    tablet: false,
    windows: {
      device: match(windowsPhone, userAgent) || match(windowsTablet, userAgent),
      phone: match(windowsPhone, userAgent),
      tablet: match(windowsTablet, userAgent)
    }
  };
  result.any = result.apple.device || result.android.device || result.windows.device || result.other.device;
  result.phone = result.apple.phone || result.android.phone || result.windows.phone;
  result.tablet = result.apple.tablet || result.android.tablet || result.windows.tablet;
  return result;
}

/**
 * @description Detect Device
 * @returns {string} 'Tablet' | 'Mobile' | 'Desktop'
 */
function detectDevice() {
  if (isMobileV2(navigator.userAgent).tablet) {
    return 'Tablet';
  }
  if (isMobileV2(navigator.userAgent).phone) {
    return 'Mobile';
  }
  return 'Desktop';
}

/**
 * @description Detect OS version
 * @returns {string} OS - name of the OS if found else 'unknown'
 */
function detectOs() {
  var nAgt = navigator.userAgent;
  var os = 'unknown';
  var clientStrings = [{
    s: 'Windows 3.11',
    r: /Win16/
  }, {
    s: 'Windows 95',
    r: /(Windows 95|Win95|Windows_95)/
  }, {
    s: 'Windows ME',
    r: /(Win 9x 4.90|Windows ME)/
  }, {
    s: 'Windows 98',
    r: /(Windows 98|Win98)/
  }, {
    s: 'Windows CE',
    r: /Windows CE/
  }, {
    s: 'Windows 2000',
    r: /(Windows NT 5.0|Windows 2000)/
  }, {
    s: 'Windows XP',
    r: /(Windows NT 5.1|Windows XP)/
  }, {
    s: 'Windows Server 2003',
    r: /Windows NT 5.2/
  }, {
    s: 'Windows Vista',
    r: /Windows NT 6.0/
  }, {
    s: 'Windows 7',
    r: /(Windows 7|Windows NT 6.1)/
  }, {
    s: 'Windows 8.1',
    r: /(Windows 8.1|Windows NT 6.3)/
  }, {
    s: 'Windows 8',
    r: /(Windows 8|Windows NT 6.2)/
  }, {
    s: 'Windows 10',
    r: /(Windows 10|Windows NT 10)/
  }, {
    s: 'Windows NT 4.0',
    r: /(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/
  }, {
    s: 'Windows ME',
    r: /Windows ME/
  }, {
    s: 'Android',
    r: /Android/
  }, {
    s: 'Open BSD',
    r: /OpenBSD/
  }, {
    s: 'Sun OS',
    r: /SunOS/
  }, {
    s: 'Linux',
    r: /(Linux|X11)/
  }, {
    s: 'iOS',
    r: /(iPhone|iPad|iPod)/
  }, {
    s: 'Mac OS X',
    r: /Mac OS X/
  }, {
    s: 'Mac OS',
    r: /(MacPPC|MacIntel|Mac_PowerPC|Macintosh)/
  }, {
    s: 'QNX',
    r: /QNX/
  }, {
    s: 'UNIX',
    r: /UNIX/
  }, {
    s: 'BeOS',
    r: /BeOS/
  }, {
    s: 'OS/2',
    r: /OS\/2/
  }, {
    s: 'Search Bot',
    r: /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/
  }];
  for (var val of clientStrings) {
    if (val.r.test(nAgt)) {
      os = val.s;
      break;
    }
  }
  return os;
}

/**
 * @description Detect OS version
 * @returns {string} OS - name of the OS if found else 'unknown'
 * This function is a lighter version of detectOs above, removes version detection for windows
 */
function detectOsLight() {
  var nAgt = navigator.userAgent;
  var os = 'unknown';
  var clientStrings = [{
    s: 'Windows',
    r: /Windows/
  }, {
    s: 'Android',
    r: /Android/
  }, {
    s: 'Open BSD',
    r: /OpenBSD/
  }, {
    s: 'Sun OS',
    r: /SunOS/
  }, {
    s: 'Linux',
    r: /(Linux|X11)/
  }, {
    s: 'iOS',
    r: /(iPhone|iPad|iPod)/
  }, {
    s: 'Mac OS X',
    r: /Mac OS X/
  }, {
    s: 'Mac OS',
    r: /(MacPPC|MacIntel|Mac_PowerPC|Macintosh)/
  }, {
    s: 'QNX',
    r: /QNX/
  }, {
    s: 'UNIX',
    r: /UNIX/
  }, {
    s: 'BeOS',
    r: /BeOS/
  }, {
    s: 'OS/2',
    r: /OS\/2/
  }];
  for (var val of clientStrings) {
    if (val.r.test(nAgt)) {
      os = val.s;
      break;
    }
  }
  return os;
}

/** Kept for legacy reasons */
/** TODO: Remove this in favor of isMobileV2 */
function isMobile() {
  var check = false;
  // tslint:disable-next-line
  (function (a) {
    // tslint:disable
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
    // tslint:enable
  })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
}
function isTouchScreen() {
  // Coarse pointer and hover: none devices are usually smartphones and other touch screen devices
  if (window.matchMedia && window.matchMedia('(pointer: coarse) and (hover: none)').matches || window.matchMedia('(any-pointer: coarse) and (any-hover: none)').matches) {
    return true;
  }

  // Stylus-based tablet devices
  if (window.matchMedia && window.matchMedia('(pointer: fine) and (hover: none)').matches || window.matchMedia('(any-pointer: fine) and (any-hover: none)').matches) {
    return true;
  }

  // for browsers that don't support the media queries above
  var msGesture = window.navigator && window.navigator.msPointerEnabled && window.MSGesture;
  var touchSupport = 'ontouchstart' in window || msGesture;
  return touchSupport;
}

/**
 * Detect if orientation of the screen is 'landscape'
 * want to use window.matchMedia? 🤔 Seems it's not working within iframe
 * @return {boolean} true if it's landscape orientation
 */
var isLandscapeOrientation = () => window.orientation === 90 || window.orientation === -90 || screen.height < screen.width;

// Snippets below were translated to TypeScript from https://www.chromium.org/updates/same-site/incompatible-clients

/**
 * Detect Firefox Browser version
 * @param major Major version number
 */
var isFirefoxVersionAtLeast = major => {
  var match = window.navigator.userAgent.match(/Firefox\/([0-9]+)\./);
  var version = match ? parseInt(match[1], 10) : 0;
  return version >= major;
};

/**
 * Check if browser runs on Mac
 */
var isMacEmbeddedBrowser = () => {
  var regex = '^Mozilla/[.d]+ (Macintosh;.*Mac OS X [_d]+) ' + 'AppleWebKit/[.d]+ (KHTML, like Gecko)$';
  return RegExp(regex).test(navigator.userAgent);
};

/**
 * Check if the browser is Chromium based
 */
var isChromiumBased = () => {
  var regex = /Chrom(e|ium)/;
  return regex.test(navigator.userAgent);
};

/**
 * Check if browser is Safari
 */
var isSafari = () => {
  var safariRegex = /Version\/.* Safari\//;
  return safariRegex.test(navigator.userAgent) && !isChromiumBased();
};

/**
 * Check if Chromium (based) browser is at least matching a specific version
 * @param major Major release number
 */
var isChromiumVersionAtLeast = major => {
  var regex = /Chrom[^ \/]+\/(\d+)[\.\d]* /;
  // Extract digits from first capturing group.
  var findChromiumVersion = navigator.userAgent.match(regex);
  var version = findChromiumVersion && parseInt(findChromiumVersion[0], 10) || 0;
  return version >= major;
};

/**
 * Determine the iOS version of user agent
 * @param major Major version number
 */
var isiOSVersion = major => {
  var regex = /\(iP.+; CPU .*OS (\d+)[_\d]*.*\) AppleWebKit\//;
  var matches = navigator.userAgent.match(regex);

  // Extract digits from first and second capturing groups.
  return matches && matches[0] === major.toString();
};

/**
 * Determine which version of Mac OSX is used
 * @param major Major version number
 * @param minor Minor version number
 */
var isMacosxVersion = (major, minor) => {
  var regex = /\(Macintosh;.*Mac OS X (\d+)_(\d+)[_\d]*.*\) AppleWebKit\//;
  var matches = navigator.userAgent.match(regex);

  // Extract digits from first and second capturing groups.
  return matches && matches[0] === major.toString() && matches && matches[1] === minor.toString();
};

/**
 * Check if the user agent is UC Browser
 */
var isUcBrowser = () => {
  var regex = /UCBrowser\//;
  return regex.test(navigator.userAgent);
};

/**
 * Find out if it's a specific version of UC Browser
 * @param major Major version number
 * @param minor Minor version number
 * @param build Build number
 */
var isUcBrowserVersionAtLeast = (major, minor, build) => {
  var regex = /UCBrowser\/(\d+)\.(\d+)\.(\d+)[\.\d]* /;

  // Extract digits from three capturing groups.
  var extractedVersions = navigator.userAgent.match(regex);
  var majorVersion = extractedVersions && parseInt(extractedVersions[0] || '0', 10) || 0;
  var minorVersion = extractedVersions && parseInt(extractedVersions[1] || '0', 10) || 0;
  var buildVersion = extractedVersions && parseInt(extractedVersions[2] || '0', 10) || 0;
  if (majorVersion !== major) {
    return majorVersion > major;
  }
  if (minorVersion !== minor) {
    return minorVersion > minor;
  }
  return buildVersion >= build;
};

/**
 * Check if the browser version is a specific one that doesn't recognize same site cookies
 */
var doesntRecognizeSameSiteCookies = () => {
  if (isUcBrowser()) {
    return !isUcBrowserVersionAtLeast(12, 13, 2);
  } else if (isChromiumBased()) {
    return isChromiumVersionAtLeast(51) && !isChromiumVersionAtLeast(67);
  } else {
    return !isFirefoxVersionAtLeast(60);
  }
};

/**
 * Check if it's a browser that has a bug with SameSite cookies where it recognizes None as Strict
 */
var hasWebkitSameSiteBug = () => {
  return isiOSVersion(12) || isMacosxVersion(10, 14) && (isSafari() || isMacEmbeddedBrowser());
};

/**
 * Check if the user's browser can not use SameSite = None for cookies
 */
var isSameSiteNoneIncompatible = () => {
  return hasWebkitSameSiteBug() || doesntRecognizeSameSiteCookies();
};

// end of UA Parser/Cookie SameSite Recognition snippets

/**
 * format number to K formatted: 1000 becames 1K
 * @name kFormatter
 * @param {number} num - number to convert
 * @returns {number | string} returns 0 in case if it's NaN,
 * returns number if value is less or equal to 999,
 * returns string if value is more than 999 > '1.0K'
 * @example
 * kFormatter(100) // => 100
 * kFormatter(1111) // => '1.1K'
 * kFormatter(1234, 2) // => '1.23K'
 */
function kFormatter(num) {
  var digitsAfterDecimal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var numb = num;
  if (typeof num === 'string') {
    numb = parseInt(num, 0);
  }
  if (Number.isNaN) {
    if (Number.isNaN(numb) || typeof numb !== 'number') {
      return 0;
    }
  } else {
    // isNaN check for IE browsers
    if (typeof numb !== 'number' || numb !== null && (numb !== numb || +numb !== numb)) {
      return 0;
    }
  }
  if (num > 999) {
    var kForm = num / 1000;
    return kForm % 1 > 0 ? "".concat(kForm.toFixed(digitsAfterDecimal), "K") : "".concat(kForm, "K");
  }
  return num;
}

/**
 * get initials from string(full name)
 * @name getInitials
 * @param {string} name - name to get initials
 * @returns {string} two first letters from 2 words for english and 1 for non-english
 * @example
 * getInitials('Gomer Simpson') // => GS
 * getInitials('Гомер Симпсон') // => Г
 * getInitials('Gomer') // => G
 */
function getInitials(name) {
  var nameArr = name.split(' ').slice(0, 2);
  var formatted = nameArr.map(word => word[0]).join('');
  // display only one letter for non-english because sybols might be wider than expected
  if (!formatted.match(/[a-zA-z1-9]/)) {
    return formatted[0];
  }
  return formatted;
}

/**
 * Convert string array('[1,2,3]') to array([1,2,3])
 * @name stringToArray
 * @param {string} item - parameter to convert
 * @return {array} - returns converted array if argument is valid, otherwise empty array
 * @example
 * stringToArray('[1,2,3]') // => [1,2,3]
 * stringToArray('') // => []
 */
function stringToArray(item) {
  try {
    var emotesArr = JSON.parse(item);
    if (Array.isArray(emotesArr)) {
      return emotesArr;
    }
    return [];
  } catch (err) {
    return [];
  }
}

/**
 * Check if string contains offensive words
 * @param {string} strToCheck - string you want to check
 * @returns {boolean}
 */
// tslint:disable-next-line
var offensiveWords = /anus|ash0le|asshole|troll|hurtz|azzhole|bastard|biatch|bitch|blowjob|blow job|butthole|c0ck|cock|dick|dildo|dild0|dildos|faggot|fuck|n1gr|nigger|orgasm|pen1s|penis|pussy|sadist|sh!t|sh1t|vag1na|vagina|whore|blowjob|b!tch|c0ck|fatass|masturbate|nigga|chuj|p0rn|vagiina/gi;
var isOffensive = strToCheck => offensiveWords.test(strToCheck);

/**
 * Check if name doesn't containt any forbidden words
 * @param {string} name - name to check
 * @returns {boolean} - `true` if forbidden word found and `false` if not
 */
var nameRegex = /[~`!#$%@\^&*+=\-\[\]\\';,/{}|\\":<>\?]|www.|[0-9]/;
var isValidName = name => !!name.trim() && !nameRegex.test(name);

/**
 * Check if email is valid
 * @param {string} email - email to check
 * @returns {boolean} - `true` if email is valid and `false` if not
 */
var emailRegex = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/;
var isValidEmail = email => !!email.trim() && emailRegex.test(email) && email.indexOf('www.') === -1;

/**
 * Remove special chars from the string, make it good looking for URL
 * @param text
 */
function slugify(text) {
  var slug = text.toString().toLowerCase().replace(/\s+/g, '-') // Replace spaces with -
  .replace(/[^\w\-]+/g, '') // Remove all non-word chars
  .replace(/\-\-+/g, '-') // Replace multiple - with single -
  .replace(/^-+/, '') // Trim - from start of text
  .replace(/-+$/, ''); // Trim - from end of text
  return slug || '-';
}

/**
 * Serialize object
 * @param {object} obj - object which needs to be serialized
 * @returns {string} - Example: id=123&name=vuukle
 */
var serialize = obj => Object.keys(obj).filter(key => obj[key] !== undefined && obj[key] !== null).map(key => "".concat(key, "=").concat(encodeURIComponent(obj[key]))).join('&');

/**
 * @name hashCode
 * @param {string} s - string from which to generate hash
 * @returns {number} - hash value
 */
function hashCode(s) {
  var str = String(s);
  var hash = 0;
  var char;
  if (str.trim().length === 0) {
    return hash;
  }
  for (var i = 0; i < str.length; i++) {
    char = str.charCodeAt(i);
    hash = (hash << 5) - hash + char; // tslint:disable-line
    // Convert to 32bit integer
    hash &= hash; // tslint:disable-line
  }

  return Math.abs(hash);
}

/**
 * Utility function to strip not allowed tags
 *
 * @example strip_tags('<p>Kevin</p> <br /><b>van</b> <i>Zonneveld</i>', '<i><b>');
 * @see {@link https://github.com/renzhn/phpjs/blob/master/website/_functions/strings/strip_tags.html}
 *
 * NOTE: it's changed a bit
 */
function strip_tags(input, allowed) {
  allowed = (((allowed || '') + '').toLowerCase().match(/<[a-z][a-z0-9]*>/g) || []).join(''); // making sure the allowed arg is a string containing only tags in lowercase (<a><b><c>)
  var tags = /<\/?([a-z][a-z0-9]*)\b[^>]*>/gi;
  return input.replace(tags, ($0, $1) => allowed.indexOf('<' + $1.toLowerCase() + '>') > -1 ? $0 : '');
}

/**
 * @name makeSafeHTML
 * @description replaces all tags inside text to be an HTML string except allowed tags in our comments
 * @param {string} s - HTML string where to convert unsafe HTML tags to string
 */
function makeSafeHTML(s) {
  return strip_tags(s, '<p><b><br/><br><i><pre><blockquote><img><li><span><a><ul><li><u><code><em><strong>');
}

/**
 * @name removeHTMLTags
 * @description removes all html tags from the string
 * @param {string} s - string from which to remove HTML tags
 * @return {string} String with remove HTML tags
 */
function removeHTMLTags(s) {
  var div = document.createElement('div');
  div.innerHTML = s;
  return div.innerText;
}

/**
 * @name removeBBcode
 * @description Clear string from BBcode syntax
 * @param {string} s - string from which to remove BBcode syntax
 * @return {string} - string without BBcode
 */
function removeBBcode(s) {
  return s.replace(/\[\/?(?:b|i|u|url|quote|code|img|color|size)*?.*?\]/gim, '');
}

/**
 * @name getTextFromHTML
 * @description Get text from HTML string with HTML tags and HTML character codes
 * @param {string} HTMLString - HTML string from which we need to get text
 * @return {string} - string from rendered html
 */
function getTextFromHTML(HTMLString) {
  var para = document.createElement('p');
  para.innerHTML = HTMLString;
  return para.innerText.trim();
}

/**
 * @name truncateString
 * @param {string} text - text to truncate
 * @param {string} maxLength - max allowed length
 * @return {string} truncated string
 */
function truncateString(text) {
  var maxLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 70;
  if (text.length > maxLength) {
    var trimmedString = text.trim().substr(0, maxLength);
    // Find if latest word has not been truncated. If yes then remove it too (in case if it's not only one long word)
    if (text.split(' ').length > 1 && text.split(' ').indexOf(trimmedString.split(' ').pop()) < 0) {
      return trimmedString.substr(0, Math.min(trimmedString.length, trimmedString.lastIndexOf(' '))).trim();
    }
    return trimmedString + '...';
  }
  return text;
}

/**
 * @name decodeString
 * @description Tries to decode string if possible, if not then returns same value as argument was
 * @param {string} str - string to decode
 * @returns {string} decoded string or same string if not possible to decode
 */
function decodeString(str) {
  try {
    return decodeURIComponent(str);
  } catch (e) {
    return str;
  }
}

/**
 * @name makeRequest
 * @description generates request function based on params
 * @param {'GET' | 'POST' | 'DELETE' | 'PUT'} method - API request method - @default 'GET'
 * @param {string} url - Request URL
 * @param {object} data - request parameters
 * @param {string} contentType - request header Content-Type
 * @param {string | undefined} authToken @default undefined - token cookie we save in records for authenticated users
 * @param {boolean} withCredentials - use withCredentials option for a request
 */
var makeRequest = function makeRequest(method, url) {
  var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var contentType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : data instanceof FormData ? '' : 'application/json';
  var authToken = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
  var withCredentials = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  return new Promise((resolve, reject) => {
    var xhr = new XMLHttpRequest();
    var reqUrl = method === 'GET' ? "".concat(url, "?").concat(typeof data === 'object' && data !== null ? serialize(data) : {}) : url;
    xhr.open(method, reqUrl, true /* Async */);

    /** Add Content-Type header if it's presented */
    if (contentType) {
      xhr.setRequestHeader('Content-Type', contentType);
    }

    /** Add Authorization header if request requires auth */
    if (authToken) {
      xhr.setRequestHeader('Authorization', "Bearer ".concat(authToken));
    }
    if (withCredentials) {
      xhr.withCredentials = true;
    }
    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        resolve(JSON.parse(xhr.response));
      } else {
        reject(new Error(xhr.statusText));
      }
    };
    xhr.onerror = () => reject(new Error(xhr.statusText));
    xhr.onabort = () => reject(new Error('cancelled'));
    method === 'GET' ? xhr.send() : data instanceof FormData ? xhr.send(data) : xhr.send(JSON.stringify(data));
  });
};

/**
 * Utility to load JS file in the document. Appends file to the head of the document
 * @param {string} src - script url
 * @param {object} attributes - attr object to add to script
 * @return {Promise<string | error>}
 */
var loadJS = function loadJS(src) {
  var attributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return new Promise((resolve, reject) => {
    /**
     * ⚠ NOTE: Scripts that are dynamically created and added to the document are async by default,
     * they don’t block rendering and execute as soon as they download, meaning they could come out in the wrong order.
     * @see https://www.html5rocks.com/en/tutorials/speed/script-loading/
     */
    var scriptTag = document.createElement('script');
    scriptTag.type = 'text/javascript';
    scriptTag.src = src;
    scriptTag.onload = () => resolve(src);
    scriptTag.onerror = reject;
    scriptTag.async = true; // Despite fact that it's async by default some publishers complain that they don't see 'async' attr. 🤷‍️
    // Set additional scrip attributes
    if (attributes instanceof Object) {
      Object.keys(attributes).forEach(key => scriptTag[key] = attributes[key]);
    }
    try {
      document.head.appendChild(scriptTag);
    } catch (err) {
      reject(err);
    }
  });
};

/**
 * Utilities for working with color
 */

/** Get relative luminance of the color */
var getLuminance = (red, green, blue) => {
  function f(x) {
    var channel = x / 255;
    return channel <= 0.03928 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
  }
  return 0.2126 * f(red) + 0.7152 * f(green) + 0.0722 * f(blue);
};

/** Darken color by amount between 0.00 - 1.00 */
var darkenColor = (rgb, amount) => {
  // Extract the red, green, and blue values from the input string
  var matches = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
  if (!matches) {
    throw new Error("Invalid RGB string: ".concat(rgb));
  }
  var [, r, g, b] = matches.map(Number);

  // Apply the darkening amount to each color component
  var newR = Math.round(r * (1 - amount));
  var newG = Math.round(g * (1 - amount));
  var newB = Math.round(b * (1 - amount));

  // Return the new color as an RGB string
  return "rgb(".concat(newR, ",").concat(newG, ",").concat(newB, ")");
};

/** Lighten color by amount between 0.00 - 1.00 */
var lightenColor = (rgb, amount) => {
  // Extract the red, green, and blue values from the input string
  var matches = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
  if (!matches) {
    throw new Error("Invalid RGB string: ".concat(rgb));
  }
  var [, r, g, b] = matches.map(Number);

  // Apply the lightening amount to each color component
  var newR = Math.round(r + (255 - r) * amount);
  var newG = Math.round(g + (255 - g) * amount);
  var newB = Math.round(b + (255 - b) * amount);

  // Return the new color as an RGB string
  return "rgb(".concat(newR, ",").concat(newG, ",").concat(newB, ")");
};

/** Get red, green, blue and luminance values of an RGB color in an array */
var getRGBInfo = rgb => {
  var rgbColorRegex = /(\d+),\s*(\d+),\s*(\d+)/;
  var matchedNumbers = rgb.match(rgbColorRegex);
  if (matchedNumbers) {
    var red = parseInt(matchedNumbers[1]);
    var green = parseInt(matchedNumbers[2]);
    var blue = parseInt(matchedNumbers[3]);
    var luminance = getLuminance(red, green, blue);
    return [red, green, blue, luminance];
  }
  return null;
};

/** Get the RGB equivalent for a color defined as a hexadecimal value */
var getRGBFromHexCode = hexColor => {
  var fullHexCode = '';
  // If it's something like #fff
  if (hexColor.length === 4) {
    // Convert it to a 6 digit hex code
    fullHexCode = "#".concat(hexColor[1]).concat(hexColor[1]).concat(hexColor[2]).concat(hexColor[2]).concat(hexColor[3]).concat(hexColor[3]);
  } else {
    fullHexCode = hexColor;
  }
  var red = parseInt(fullHexCode.slice(1, 3), 16);
  var green = parseInt(fullHexCode.slice(3, 5), 16);
  var blue = parseInt(fullHexCode.slice(5, 7), 16);
  var rgbCode = "rgb(".concat(red, ",").concat(green, ",").concat(blue, ")");
  return rgbCode;
};

/**
 * Create an RGB color from RGBA
 *
 * @param rgba The rgba string like rgba(0, 0, 0, 0)
 * @returns RGB color like rgb(255, 255, 255)
 */
function getRGBColorFromRGBA(rgba) {
  var parseRgba = rgba.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);
  if (parseRgba) {
    var [, red, green, blue, alpha] = parseRgba;
    var adjustedAlpha = 1 - Number(alpha);
    var adjustedRed = Math.min(Math.round(Number(red) + adjustedAlpha * 255), 255);
    var adjustedGreen = Math.min(Math.round(Number(green) + adjustedAlpha * 255), 255);
    var adjustedBlue = Math.min(Math.round(Number(blue) + adjustedAlpha * 255), 255);
    return "rgb(".concat(adjustedRed, ",").concat(adjustedGreen, ",").concat(adjustedBlue, ")");
  } else {
    return rgba;
  }
}

export { darkenColor, decodeString, detectBrowser, detectDevice, detectOs, detectOsLight, doesntRecognizeSameSiteCookies, getBrowserName, getInitials, getLuminance, getRGBColorFromRGBA, getRGBFromHexCode, getRGBInfo, getTextFromHTML, getURLParams, hasWebkitSameSiteBug, hashCode, isChromiumBased, isChromiumVersionAtLeast, isFirefoxVersionAtLeast, isLandscapeOrientation, isMacEmbeddedBrowser, isMacosxVersion, isMobile, isMobileV2, isOffensive, isSafari, isSameSiteNoneIncompatible, isTouchScreen, isUcBrowser, isUcBrowserVersionAtLeast, isValidEmail, isValidName, isiOSVersion, kFormatter, lightenColor, loadJS, makeDevLog, makeRequest, makeSafeHTML, removeBBcode, removeHTMLTags, serialize, slugify, stringToArray, truncateString };
//# sourceMappingURL=index.mjs.map
